// extracted by mini-css-extract-plugin
export default {"uploadContainer":"CompanyGameConfiguration_uploadContainer__B5bs2","uploadLabel":"CompanyGameConfiguration_uploadLabel__GInoB","upload":"CompanyGameConfiguration_upload__nQOn1"};